// ---------------------------------------------------------

import Component from './component';
import transform from './transformer';

// ---------------------------------------------------------

const TopicCarousel = (props) => <Component {...transform(props)} />;

export default TopicCarousel;

// ---------------------------------------------------------

export { Component as component, transform as transformer };
